import { createRouter } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { rootRoute } from './routes/__root';
import { indexRoute } from './routes/index';
import { emailAccountsRoute } from './routes/email-accounts';
// DISABLED: /dashboard is switched off — see routes/dashboard.tsx.
// import { dashboardRoute } from './routes/dashboard';
import { settingsRoute } from './routes/settings';
import { billingRoute } from './routes/billing';
import { notificationsRoute } from './routes/notifications';
import { actionItemsRoute } from './routes/action-items';
import { auditLogsRoute } from './routes/audit-logs';
import { templatesRoute } from './routes/templates';
import { apiKeysRoute } from './routes/api-keys';
import { partnerIntegrationRoute } from './routes/partner-integration';
import { designRoute } from './routes/design';
import { loginRoute } from './routes/login';
import { registerRoute } from './routes/register';
import { emailAccountDetailRoute } from './routes/email-accounts.$id';
import { emailAccountWarmupSettingsRoute } from './routes/email-accounts.$id.warmup-settings';
import { emailAccountActivityRoute } from './routes/email-accounts.$id.activity';
import { emailAccountsBulkWarmupSettingsRoute } from './routes/email-accounts-bulk-warmup-settings';
import { connectAccountRoute } from './routes/email-accounts.connect';
import { connectMailboxRoute } from './routes/connect-mailbox';
import { oauthCallbackRoute } from './routes/auth/oauth-callback';
import { magicLinkCallbackRoute } from './routes/auth/magic-link-callback';
import { forgotPasswordRoute } from './routes/auth/forgot-password';
import { resetPasswordRoute } from './routes/auth/reset-password';
import { completeProfileRoute } from './routes/auth/complete-profile';
import { acceptInviteRoute } from './routes/auth/accept-invite';
import { acceptInviteLinkRoute } from './routes/auth/accept-invite-link';
import { Error404 } from './components/organisms/Error404';

const routeTree = rootRoute.addChildren([
  indexRoute,
  emailAccountsRoute,
  emailAccountsBulkWarmupSettingsRoute,
  connectAccountRoute,
  connectMailboxRoute,
  // dashboardRoute,
  settingsRoute,
  billingRoute,
  actionItemsRoute,
  notificationsRoute,
  auditLogsRoute,
  templatesRoute,
  apiKeysRoute,
  partnerIntegrationRoute,
  designRoute,
  loginRoute,
  registerRoute,
  emailAccountDetailRoute,
  emailAccountWarmupSettingsRoute,
  emailAccountActivityRoute,
  oauthCallbackRoute,
  magicLinkCallbackRoute,
  forgotPasswordRoute,
  resetPasswordRoute,
  completeProfileRoute,
  acceptInviteRoute,
  acceptInviteLinkRoute,
]);

export interface RouterContext {
  queryClient: QueryClient;
}

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  // Rendered whenever a navigation lands on a path that doesn't match any
  // configured route. Sits inside the root layout (AppShell), so the sidebar
  // and chrome remain available when the user takes a wrong turn.
  defaultNotFoundComponent: () => <Error404 />,
  // The real QueryClient is injected at mount time via `RouterProvider`'s
  // `context` prop in `main.tsx`. The non-null assertion is the documented
  // pattern from TanStack Router examples; runtime always supplies it.
  context: { queryClient: undefined! },
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
